
export enum UserRole {
  ADMIN = 'ADMIN',
  CANDIDATE = 'CANDIDATE'
}

export enum AttemptStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  ABANDONED = 'ABANDONED',
  LOCKED = 'LOCKED'
}

export interface College {
  id: string;
  name: string;
  isEnabled: boolean;
  participantCount: number;
  allowedStudents?: { id: string; name?: string; department?: string }[];
}

export interface Question {
  id: string;
  assessmentId: string;
  text: string;
  options: {
    A: string;
    B: string;
    C: string;
    D: string;
  };
  correctOption: 'A' | 'B' | 'C' | 'D';
  marks: number;
  category?: string;
}

export interface Assessment {
  id: string;
  name: string;
  duration: number; // in minutes
  questionCount: number;
  resumePin: string; // The "Assessment Access PIN" for proctors
  maxViolations: number;
  allowedColleges: string[]; // IDs
  isActive: boolean;
  bufferTime?: number; // Minutes to wait before marking as ABANDONED
  welcomeText: string;
  logoUrl?: string;
  requireCamera?: boolean;
}

export interface AuditLog {
  id: string;
  timestamp: number;
  type: 'TAB_SWITCH' | 'DUPLICATE_TAB' | 'PIN_FAILURE' | 'AUTO_SUBMIT' | 'START' | 'SUBMIT';
  details: string;
}

export interface CandidateAttempt {
  id: string;
  candidateName: string;
  department?: string;
  studentId: string; // Added studentId
  collegeId: string;
  collegeName?: string; // Snapshotted at start time
  assessmentId: string;
  startTime: number;
  endTime?: number;
  status: AttemptStatus;
  responses: Record<string, string>; // questionId -> selectedOption
  violations: number;
  score?: number;
  auditLogs: AuditLog[];
  lastSnapshot?: string; // Base64 image data
  lastSnapshotTime?: number;
  questionOrder: string[]; // shuffled IDs
}

export interface SystemSettings {
  recruitAccessPin: string;
  studentLoginImage?: string;
  studentLoginTitle?: string;
  studentLoginMessage?: string;
  updatedAt?: number;
}

export interface AssessmentLink {
  id: string; // The custom URL slug
  collegeId: string;
  assessmentId: string;
  createdAt: number;
}

export interface AppState {
  colleges: College[];
  assessments: Assessment[];
  questions: Question[];
  attempts: CandidateAttempt[];
  settings: SystemSettings;
  currentUser: {
    role: UserRole;
    id?: string;
    name?: string;
    department?: string;
  } | null;
}
